import { NgModule } from '@angular/core';

import { AppLiteModule } from '../../app-lite/app.module';
import { CheckaService } from './checka.service';

@NgModule({
  imports: [
    AppLiteModule
  ],
  providers: [
    CheckaService
  ]
})
export class CheckaModule {}
